module.exports = "  <img #avatar class=\"icon\" (click)=\"iconClicked()\">\n  <ion-badge *ngIf=\"badge > 0\">{{badge}}</ion-badge>\n"